<template>
    <div class="flex gap-4 overflow-x-auto pb-2">
        <div
            v-for="item in items"
            :key="item.id"
            class="w-64 flex-shrink-0 rounded-xl border border-theme-border bg-theme-card p-4 text-center"
        >
            <div class="mx-auto h-16 w-16 overflow-hidden rounded-full">
                <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    :alt="item.name"
                    class="h-full w-full object-cover"
                />
                <PlaceholderImage
                    v-else
                    :label="item.name"
                    bg="var(--color-stack-tile-bg)"
                    class="h-full w-full"
                />
            </div>
            <p class="mt-3 text-sm italic text-stack-text">
                &ldquo;{{ item.quote }}&rdquo;
            </p>
            <p class="mt-2 text-sm font-semibold text-stack-primary">
                {{ item.name }}
            </p>
        </div>
    </div>
</template>

<script>
import PlaceholderImage from "@/components/editor/PlaceholderImage.vue";

export default {
    name: "TestimonialsSegment",
    components: { PlaceholderImage },
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false }
    }
};
</script>
